/** Alt для изображений авто — SEO + a11y. */
export function carListingImageAlt(car: {
  brand: string;
  model: string;
  year: number;
  location?: string | null;
  title?: string;
}): string {
  const city = car.location?.split(",")[0]?.trim() || "Душанбе";
  return `Аренда ${car.brand} ${car.model} ${car.year} в ${city}`;
}
